import {
  Dropdown,
  DropdownButton,
  DropdownItem,
  DropdownItems,
} from "@transfr-inc/dashboard-components/forms";
import clsx from "clsx";
import React, { useMemo } from "react";
import { useProviderIcons } from "@queries/provider-icon";
import "./integration-select.scss";

const IntegrationSelect = ({ providers, onSelectProvider, icon }) => {
  const providerIds = providers?.map((p) => p.id) || [];
  const { data: icons = {} } = useProviderIcons(providerIds, {
    enabled: providerIds.length > 0,
  });

  const providersWithIcons = useMemo(() => {
    return providers.map((provider) => ({
      ...provider,
      icon: icons[provider.id],
    }));
  }, [providers, icons]);

  return (
    <Dropdown
      className={clsx("integration-dropdown", !!icon && "icon-only")}
      selected={{}}
      onOptionSelected={onSelectProvider}
    >
      <DropdownButton
        iconOnly={!!icon}
        icon={icon}
        className={"integration-dropdown-button primary"}
      >
        {!icon && "Add a new integration"}
      </DropdownButton>
      <DropdownItems>
        {providersWithIcons?.map((provider) => (
          <DropdownItem
            key={provider.id}
            value={provider}
            className={"integration-dropdown-item"}
          >
            <img
              className="provider-image"
              src={provider.icon}
              alt={provider.name}
            />
          </DropdownItem>
        ))}
      </DropdownItems>
    </Dropdown>
  );
};

export default IntegrationSelect;
